import { render, staticRenderFns } from "./addOrEdit3.vue?vue&type=template&id=2498e030&scoped=true"
import script from "./addOrEdit3.vue?vue&type=script&lang=js"
export * from "./addOrEdit3.vue?vue&type=script&lang=js"
import style0 from "./addOrEdit3.vue?vue&type=style&index=0&id=2498e030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2498e030",
  null
  
)

export default component.exports